import React from "react";

const Question = (props) => {
  const { data } = props;
  const { nextPage } = props;
  const { count } = props;

  const testMbti = [
    [
      "Q1",
      "새 학년 새 학기 수업 시간. 이 수업에 팀플이 있다는 걸 알게 되었다.",
      "이 때 내가 든 생각은?",
      "'새로운 사람 만나는 건 좋지'",
      "괜찮다고 생각한다",
      "E",
      " '팀플 너무 싫어 드랍할 걸...' ",
      "벌써부터 힘들다고 생각한다",
      "I",
    ],

    [
      "Q2",

      "교수님이 짜신 팀플 조가 공지에 올라왔다. 그러나 아무도 단톡방을 만들지 않는데...",
      "내가 나설까??",
      "  '딘톡방 만드는게 뭐가 어렵다고'",
      "바로 만든다",
      "J",
      " '다른 사람이 만들겠지'",
      "만들지 않고 기다린다",
      "P",
    ],

    [
      "Q3",

      "팀플 단톡방이 만들어졌지만, 아무도 인사하지 않는데...",
      "내가 먼저 말을 꺼낼까?",
      "'팀플할려면 어차피 친해져야 하잖아'",
      "먼저 나서서 분위기를 푼다",
      "E",
      "'아무도 인사 안하는데 내가 굳이 ...?'",
      "인사 안하고 다른 사람이 인사하면 인사한다",
      "I",
    ],

    [
      "Q4",

      "  발표 주제를 정하는 시간",
      "이 때 나의 행동은?",
      " '이것도 괜찮고 이것도 괜찮지 않을까?'",
      "이것저것 아이디어를 낸다",
      "N",
      "'음 저 주제는 이런 부분이 부족한데...'",
      "다른 사람이 낸 주제를 피드백 해준다",
      "S",
    ],

    [
      "Q5",
      "다른 팀원 낸 주제가 우리 발표랑 별로 안 맞는 것 같아",
      "이 때 나의 행동은?",
      '"이런 주제는 이 부분에서 안 맞는 것 같아요! 다른 주제로 하죠"',
      "별로 안맞는다고 바로 말한다",
      "T",
      ' "좋은 주제인데... 이 부분에서 조금 안맞을수도 있을 것 같아요" ',
      "돌려서 말한다",
      "F",
    ],

    [
      "Q6",
      " 주제가 정해진 뒤 역할을 분담하는 시간, 역할 분담이 제대로 안되는 것  같은데...",
      "이 때 나의 행동은?",
      "''너무 답답해!'",
      "나서서 역할분담을 한다",
      "J",
      "'이러다가 정해지겠지'",
      "굳이 나서지 않는다",
      "P",
    ],

    [
      "Q7",
      "발표자를 정하는 시간",
      "이 때 나의 행동은?",
      "'발표가 뭐 어렵다고'",
      "내가 발표하겠다고 한다",
      "E",
      "'발표 싫어. 다른 역할 할래'",
      "다른 사람이 발표한다고 하길 기다린다",
      "I",
    ],

    [
      "Q8",
      "우여곡절 끝에 역할이 모두 분담되었다. 난 발표와 자료조사를 분담하게 되었다.",
      "나에게 주어진 파트는 언제까지 마칠까?",
      "'얼른 끝내야지'",
      "최대한 빨리 끝내려고 노력한다",
      "J",
      "'좀 남았으니까...'",
      "중으로 미룬다",
      "P",
    ],

    [
      "Q9",
      "팀플 과제 마감날, 어쩌다보니 나에게 분담된 과제를 제대로 하지 못했다!",
      "이 때 내 생각은?",
      "'내가 이걸 못해서 팀플이 망하면 학점이 망하겠지... 어떡하냐?'",
      "미래에 대해 걱정한다",
      "N",
      "'왜 과제를 제대로 못했지?'",
      "원인에 대해 생각한다",
      "S",
    ],

    [
      "Q10",
      "막판 스퍼트를 내 팀플 과제를 끝냈다. 근데... 팀원의 자료조사 부분이 부족한 것 같다.",
      "이 때 내 생각은?",
      '"너무 부족하게 해오신 것 같아요"',
      "바로 다시 해오라 한다",
      "T",
      '"이 부분만 조금 수정해주실 수 있나요?"',
      "최대한 돌려서 말한다",
      "F",
    ],
    [
      "Q11",
      "대망의 발표 전 날,",
      "이 때 나의 모습은?",
      "'실수하면 어떡하지?'",
      "여러 걱정에 여러번 연습한다",
      "N",
      '"이 정도면 괜찮을 것 같아"',
      "몇 번 연습하다 미련없이 잔다",
      "S",
    ],
    [
      "Q12",
      "대망의 발표 시간, 완벽하게 발표 후 질문 시간을 갖는데, 다소 공격적인 질문이 들어온다.",
      "이 때 나는?",
      "'그 부분은 이렇게 대답할 수 있지'",
      "딱히 타격없이 대답한다",
      "T",
      "'뭐지 저 사람 나 싫어하나'",
      "대답은 하지만 기분이 다운된다",
      "F",
    ],
  ];

  function firstClcik() {
    data.push(testMbti[count][5]);

    nextPage();
  }

  function secondClcik() {
    data.push(testMbti[count][8]);

    nextPage();
  }
  localStorage.setItem("MBTI", JSON.stringify(data));

  return (
    <div className="contentsWrap">
      <div className="contents">
        <>
          <h1>{testMbti && testMbti[count][0]}</h1>
          <p>
            {testMbti && testMbti[count][1]}
            <br></br>
            <span> {testMbti && testMbti[count][2]}</span>
          </p>
          <div className="buttonWrap">
            <button onClick={firstClcik}>
              {testMbti && testMbti[count][3]}
              <br></br>
              <span> {testMbti && testMbti[count][4]}</span>
            </button>
            <button onClick={secondClcik}>
              {testMbti && testMbti[count][6]}
              <br></br>
              <span> {testMbti && testMbti[count][7]}</span>
            </button>
          </div>
        </>
      </div>
    </div>
  );
};

export default Question;
